import { Component, OnInit } from '@angular/core'
import { BreakpointService, FacetList, FacetService, ProductFacetNavigationComponent } from '@spartacus/storefront'
import { Observable } from 'rxjs'

@Component({
    selector: 'app-custom-product-facet-navigation',
    templateUrl: './custom-product-facet-navigation.component.html',
    styleUrls: ['./custom-product-facet-navigation.component.scss'],
    standalone: false
})
export class CustomProductFacetNavigationComponent extends ProductFacetNavigationComponent implements OnInit {
  facetList$: Observable<FacetList>

  constructor(
    protected breakpointService: BreakpointService,
    private facetService: FacetService
  ) {
    super(breakpointService)
  }

  ngOnInit(): void {
    this.facetList$ = this.facetService.facetList$
  }
}
